import React from "react"
import { useHistory } from "react-router-dom"

import {
	Edit as EditIcon,
	BarChart,
	FileCopyOutlined,
	InfoOutlined
} from "@material-ui/icons"
import { Grid } from "@material-ui/core"
import { MoreOptionsMenu, Notification } from "@/components"
import AdvertisementSetupDialog from "@/pages/Admin/TrackableLinks/AdvertisementSetupDialog"

import useStyles from "@/pages/Admin/TrackableLinks/ActionsDropdown/styles"
import copy from "copy-to-clipboard"
import { mountTrackableLinkMetricsPagePath } from "@/utils/trackableLinks"

type ActionsDropdownProps = {
	copyLinkUrl: string
	trackableLinkId: number
}

const ActionsDropdown: React.FC<ActionsDropdownProps> = (props) => {
	const { copyLinkUrl, trackableLinkId } = props
	const history = useHistory()

	const classes = useStyles()
	const linkToRedirectToMetrics = mountTrackableLinkMetricsPagePath(trackableLinkId?.toString())

	const handleToRedirectTrackableLinkMetrics = () => {
		history.push(linkToRedirectToMetrics)
	}

	const handleToRedirectEditTrackableLinkPage = () => {
		history.push(`/admin/tools/trackable-links/${trackableLinkId}/edit`)
	}

	const handleOpenAdvertisementSetupDialog = () => {
		AdvertisementSetupDialog.open({
			openDialog: true,
			title: "COMO CONFIGURAR MEU LINK 🤔",
			shouldRedirectToMetrics: false,
			trackableLinkId
		})
	}

	const copyHandler = () => {
		copy(copyLinkUrl)
		Notification.success({ message: "Link copiado com sucesso!" })
	}

	return (
		<Grid container>
			<Grid item justifyContent="center" alignItems="center" className={classes.item}>
				<MoreOptionsMenu
					iconSize="small"
					options={[
						{
							title: "Como configurar meu link",
							icon: <InfoOutlined />,
							showIcon: true,
							onClick: handleOpenAdvertisementSetupDialog
						},
						{
							title: "Ver métricas",
							icon: <BarChart />,
							showIcon: true,
							onClick: handleToRedirectTrackableLinkMetrics
						},
						{
							title: "Copiar link",
							icon: <FileCopyOutlined />,
							showIcon: true,
							onClick: copyHandler
						},
						{
							title: "Editar",
							icon: <EditIcon />,
							showIcon: true,
							onClick: handleToRedirectEditTrackableLinkPage
						}
					]}
				/>
			</Grid>
		</Grid>
	)
}

export default ActionsDropdown
